export default {
  BTN_POST: 'Submit',
  BTN_CANCEL: 'Cancel',
  BTN_UPLOAD: 'Upload image',
  BTN_ADD: 'Add new',
  BTN_MAKE_IN_ACTIVE: 'Make inactive',
  ALL_FIELDS_REQUIRED: '* All starred fields are required.',
  BTN_DELETE: 'Delete',
}
